import React from 'react';
import styles from './LoadingOverlay.module.css';

const LoadingOverlay = () => {
  return (
    <div className={styles.overlay}>
      <div className={styles.spinnerContainer}>
        {/* Multi-ring spinner */}
        <div className={styles.spinner}>
          <div className={styles.ring}></div>
          <div className={styles.ring}></div>
          <div className={styles.ring}></div>
        </div>
        
        {/* Loading text with shimmer effect */}
        <div className={styles.loadingText}>
          <span className={styles.shimmer}>در حال بارگذاری...</span>
        </div>
        
        {/* Floating particles */}
        <div className={styles.particles}>
          <span className={styles.particle}></span>
          <span className={styles.particle}></span>
          <span className={styles.particle}></span>
          <span className={styles.particle}></span>
        </div>
      </div>
    </div>
  );
};

export default LoadingOverlay;